import React from 'react';
import bigLogoPresentation from '../../assets/images/big-logo-presentation.svg';

const containerStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: '#000000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const imageStyle = {
  width: '60vw',
  maxWidth: '280px',
  height: 'auto',
};

const MobileSplashScreen = () => (
  <div style={containerStyle}>
    <img
      src={bigLogoPresentation}
      alt="Loopino"
      style={imageStyle}
    />
  </div>
);

export default MobileSplashScreen;
